import { Navigate, Route, Routes } from "react-router-dom";

import PreventiveMaintenance from "./preventiveMaintenance";
import FleetManagerAppointmentsRoutes from "./appointments/routes";
import MaintenanceMonitoring from "./maintenanceMonitoring";

const FleetManagerRoutes = (props: any) => (
  <Routes>
    <Route path="/" element={<Navigate to="/fleet-manager/preventive-maintenance" />} />
    <Route path="/preventive-maintenance" element={<PreventiveMaintenance {...props} />} />
    <Route path="/maintenance-monitoring" index element={<MaintenanceMonitoring {...props} />} />
    <Route path="/appointments/*" index element={<FleetManagerAppointmentsRoutes {...props} />} />
  </Routes>
);

export default FleetManagerRoutes;
